import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadScalingPoliciesQueryKey } from 'hooks/queries/workload-optimization/useWorkloadScalingPoliciesQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

type UseDeleteWorkloadScalingPolicyMutationArgs = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useAssignWorkloadsToPolicyMutation = ({
  onSuccess,
  onError,
}: UseDeleteWorkloadScalingPolicyMutationArgs = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.workloadOptimization.assignWorkloadsToPolicy,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadScalingPoliciesQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });
      onSuccess?.();
    },
    onError,
  });
};
